import Vue from 'vue';
import Router from 'vue-router';
import store from './store/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'HOME',
      button: true,
      component: () => import('./views/Home.vue')
    },
    {
      path: '/ACTS',
      name: 'ACTS',
      alias: '/acts/*',
      button: true,
      meta: {
        user: true
      },
      component: () => import('./views/ACTS.vue')
    },
    {
      path: '/Samsara',
      name: 'Samsara',
      alias: '/samsara/*',
      button: true,
      component: () => import('./views/Samsara.vue')
    },
    {
      path: '/Users',
      name: 'User Management',
      button: false,
      meta: {
        admin: true
      },
      component: () => import('./views/Users.vue')
    },
    {
      path: '/redirect',
      name: 'REDIRECT',
      button: false,
      component: () => import('./views/Redirect.vue')
    },
    {
      path: '*',
      redirect: '/',
      button: false
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.name !== 'REDIRECT') {
    store.state.redirect = '';
  }
  if (to.meta.admin) {
    if (store.state.admin) {
      next();
    } else {
      store.state.redirect = to.name;
      next({ name: 'REDIRECT' });
    }
  } else if (to.meta.user) {
    if (store.state.user) {
      next();
    } else {
      store.state.redirect = to.name;
      next({ name: 'REDIRECT' });
    }
  } else {
    next();
  }
});

export default router;